module.exports = __webpack_public_path__ + "static/img/平台_图1@2x.f73de16b.png";